module.exports = __webpack_public_path__ + "img/rotate-clockwise.2bb96603.svg";